import { SubscriptionInterval } from '@/models/Groups'

export const formatNameForAvatar = (name: string): string => {
  const nameArr = name?.split(/\s+/)
  return nameArr
    ?.map(item => item[0])
    .join('')
    .toUpperCase()
}

export const capitalizeFirstLetterName = (item: string): string => {
  return `${item[0]?.toUpperCase()}${item?.slice(1)}`
}

export function capitalizeWord(word: string): string {
  // Check if the word is not empty
  if (word.length === 0) {
    return word
  }

  // Capitalize the first letter and convert the rest to lowercase
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
}
export const getShortTextForSubscriptionInterval = (
  interval: SubscriptionInterval
): string => {
  return interval === SubscriptionInterval.MONTHLY
    ? 'm'
    : interval === SubscriptionInterval.ANNUAL
    ? 'y'
    : 'w'
}

export function getAbbreviatedText(str: string, length: number): string {
  if (str.length <= length) {
    return str
  }
  return str.substring(0, length) + '...'
}
